import React from 'react';
import { ArrowDownOutlined, ArrowUpOutlined, MinusOutlined } from '@ant-design/icons';

export function DeltaBadge({
  deltaPct,
  trend,
}: {
  deltaPct?: number | null;
  trend?: 'up' | 'down' | 'flat';
}) {
  let direction: 'up' | 'down' | 'flat' = trend ?? 'flat';
  if (deltaPct != null && !trend) {
    if (deltaPct > 0.5) direction = 'up';
    else if (deltaPct < -0.5) direction = 'down';
    else direction = 'flat';
  }

  const pct = deltaPct != null ? `${Math.abs(deltaPct).toFixed(1)}%` : '—';
  const color =
    direction === 'up' ? 'var(--oi-emerald)' : direction === 'down' ? 'var(--oi-crimson)' : 'var(--oi-amber)';

  const icon =
    direction === 'up' ? <ArrowUpOutlined /> : direction === 'down' ? <ArrowDownOutlined /> : <MinusOutlined />;

  return (
    <span style={{ color, fontSize: 14, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {icon} {pct}
    </span>
  );
}
